
import Vue from 'vue'
import HymnalHymnInfo from '~/components/hymnal/HymnInfo.vue'
import {
  images,
  markdownMetadataDescription,
  metadata,
} from '~/assets/ts/utils/metadata'
import { HymnApi } from '~/apiclient/apihymns'
import SiteLayoutFoundationsPsalter from '~/components/site/layout/FoundationsPsalter.vue'

export default Vue.extend({
  components: { SiteLayoutFoundationsPsalter, HymnalHymnInfo },
  middleware: ['fetchHymn'],
  head(this: any) {
    return metadata(this, {
      title: this.psalm.title,
      description: markdownMetadataDescription(this.psalm.verses),
      images: images(
        `https://sermonaudio.com/images/og-psalter-foundations.jpg`,
        true
      ),
    })
  },
  computed: {
    psalmID(): string {
      return this.$route.params.psalmID
    },
    psalm(): HymnApi | undefined {
      return this.$store.getters['hymns/hymn'](this.psalmID)
    },
  },
})
